import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/effects/reflection/config';
import { EffectPropsField } from '@editor/src/js/constants';
import { IReflectionFeature } from './reflection-interface';

@Controller({ formItems: FORM_CONFIGS })
export class FontReflectionController {
    constructor(@Loader(IReflectionFeature) private loader: IDynamicLoader<IReflectionFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.FONT_REFLECTION, 'content')
    public renderPreset(): any {
        return this.feature.renderPreset();
    }

    @Form(FormItemName.FONT_REFLECTION_SIZE, 'value')
    public getSize(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.TEXT_REFLECTION, { size: this.feature.size });
    }

    @Form(FormItemName.FONT_REFLECTION_SIZE, 'onChange')
    public changeSize(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const sizeObj = this.feature.getValidValue({ size: value }, from);
        this.feature.handleReflectionChange(sizeObj, dragEnd);
    }

    @Form(FormItemName.FONT_REFLECTION_BLUR, 'value')
    public getBlur(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.TEXT_REFLECTION, { blurRad: this.feature.blur });
    }

    @Form(FormItemName.FONT_REFLECTION_BLUR, 'onChange')
    public changeBlur(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const blurRadObj = this.feature.getValidValue({ blurRad: value }, from);
        this.feature.handleReflectionChange(blurRadObj, dragEnd, from);
    }

    @Form(FormItemName.FONT_REFLECTION_DISTANCE, 'value')
    public getDist(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.TEXT_REFLECTION, { dist: this.feature.dist });
    }

    @Form(FormItemName.FONT_REFLECTION_DISTANCE, 'onChange')
    public changeDist(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const distObj = this.feature.getValidValue({ dist: value }, from);
        this.feature.handleReflectionChange(distObj, dragEnd, from);
    }

    @Form(FormItemName.FONT_REFLECTION_OPACITY, 'value')
    public getOpacity(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.TEXT_REFLECTION,
            { [EffectPropsField.STARTOPACITY.name]: this.feature.opacity },
        );
    }

    @Form(FormItemName.FONT_REFLECTION_OPACITY, 'onChange')
    public changeOpacity(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const opacityObj = this.feature.getValidValue({ [EffectPropsField.STARTOPACITY.name]: value }, from);
        this.feature.handleReflectionChange(opacityObj, dragEnd, from);
    }
}
